import React from "react";

export const GreenLines = ({ style }: { style?: React.CSSProperties }) => (
  <svg
    width="97"
    style={style}
    height="114"
    viewBox="0 0 97 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M63.5217 102.562C66.0564 104.054 67.0017 107.503 65.6333 110.265C64.2648 113.028 61.1008 114.058 58.5661 112.567L63.5217 102.562ZM7.30732 82.8893C4.92663 81.2435 4.17193 77.819 5.62949 75.1682C7.11026 72.4753 10.3136 71.6003 12.7844 73.2142L14.3305 74.2169C30.3209 84.5042 46.6617 92.6414 63.5217 102.562L58.5661 112.567C42.0995 102.877 24.0464 93.8255 7.42187 82.9664L7.30732 82.8893Z"
      fill="#008A00"
    />
    <path
      d="M1.91291 23.1928C0.0572068 20.7916 0.338575 17.2055 2.54165 15.1829C4.74477 13.1604 8.03509 13.4675 9.89081 15.8686C29.9632 41.8414 52.9991 65.898 76.5617 88.3978C78.7282 90.4667 78.9455 94.0584 77.0473 96.4198C75.149 98.781 71.854 99.0182 69.6874 96.9495C45.9123 74.2466 22.4518 49.7691 1.91291 23.1928Z"
      fill="#008A00"
    />
    <path
      d="M54.6259 8.77042C54.1113 5.74942 55.8991 2.81533 58.6729 2.17435C61.4908 1.52328 64.2593 3.48518 64.8568 6.55636L64.9578 7.06681C67.1189 17.8174 71.8267 30.4222 77.3517 43.3011C82.6755 55.7108 88.3419 67.4666 93.1793 78.2508L94.1354 80.3944C95.3884 83.2213 94.3014 86.6201 91.7077 87.9857C89.114 89.3513 85.9955 88.1666 84.7426 85.3397L83.84 83.317C79.2275 73.0395 73.1592 60.3705 67.9023 48.1166C62.2291 34.8924 57.0255 21.1136 54.6524 8.91459L54.6259 8.77042Z"
      fill="#008A00"
    />
  </svg>
);
